export default {"src":"/_next/static/media/shipping11.b4eb845f.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};